import { create } from 'zustand';
import { persist } from 'zustand/middleware';
import { DataStateTable, StateResponseData } from '@/interfaces';
import { PaginationResponse } from '@/modules/Products/interfaces';

interface StateStore {
	dataState: DataStateTable[];
	pagination: PaginationResponse;
	setStateData: (data: StateResponseData) => void;
	clearStateData: () => void;
	getStateData: () => StateResponseData;
}

// Inicializar con valores por defecto
const EMPTY_PAGINATION: PaginationResponse = {
	total: 0,
	page: 1,
	limit: 10,
};

export const useStateStore = create<StateStore>()(
	persist(
		(set, get) => ({
			dataState: [],
			pagination: EMPTY_PAGINATION,
			setStateData: (data: StateResponseData) => set({ 
				dataState: data.dataState,
				pagination: data.pagination 
			}),
			clearStateData: () => set({ 
				dataState: [], 
				pagination: EMPTY_PAGINATION 
			}),
			getStateData: () => ({
				dataState: get().dataState,
				pagination: get().pagination
			}),
		}),
		{ name: 'state-store' },
	),
);
